import {
  FRONT_DOOR_STANDARDS_PATH,
  indexStandards,
  StandardsResponse,
  StandardSummary,
} from "@internal/plugin-front-door-common";
import { useFrontDoorJson } from "../frontDoorApi";

const byId = (body: StandardsResponse) => indexStandards(body.standards);

/** The blackboard-standards registry by id; undefined until read, and when it can't be. */
export function useStandards():
  | ReadonlyMap<string, StandardSummary>
  | undefined {
  return useFrontDoorJson(FRONT_DOOR_STANDARDS_PATH, "Standards", byId);
}
